var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingDown = function SvgTrendingDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.193 6.899a.6.6 0 0 1 .848 0l5.693 5.692 4.282-4.28.094-.078a.6.6 0 0 1 .755.077l6.976 6.976v-4.199a.6.6 0 0 1 1.2 0v5.647a.6.6 0 0 1-.047.23q-.012.026-.026.05-.014.027-.029.052a.6.6 0 0 1-.167.168q-.01.006-.021.01a1 1 0 0 1-.082.044q-.023.008-.044.013-.034.013-.069.02-.015.003-.03.004-.042.008-.085.01h-5.647a.6.6 0 0 1 0-1.2h4.198L13.44 9.582 9.16 13.865a.6.6 0 0 1-.849 0L2.193 7.747a.6.6 0 0 1 0-.848"
  })));
};
export default SvgTrendingDown;